export default __webpack_public_path__ + "static/media/image.quadrate-tech-solutions-private-limited.2d8779ad.png";